import {AnyAction} from "redux";
import {SET_SCORE, ADD_SCORE, UPDATE_SCORE} from "./action";


/**
 * set the score
 * @param score
 * @return {{type: any, payload: {location_id: any}}}
 */
export function setScore(score: number) : AnyAction
{
    return {type: SET_SCORE, payload: {score}};
}


/**
 * add to the current score
 * @return {{type: string, payload: {}}}
 */
export function addScore(score: number) : AnyAction
{
    return {type: ADD_SCORE, payload: {score}};
}


/**
 * reset the score
 * @return {{type: string, payload: {}}}
 */
export function resetScore() : AnyAction
{
    return {type: SET_SCORE, payload: {score: 0}};
}


/**
 * update the score
 * @return {{type: string, payload: {}}}
 */
export function updateScore() : AnyAction
{
    return {type: UPDATE_SCORE, payload: {}};
}


// WEBPACK FOOTER //
// ./src/ts/store/actions/score.ts